import { RouteTypes } from 'consts';
import Header from 'containers/Header';
import Table from 'containers/Table';
import { useList } from 'hooks/list';
import { useEffect, ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { RfUiBreadcrumbs, RfUiModal } from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  setLoading,
  setModalDraftType,
  setMsgSubmit,
} from 'store/app/actions';
import {
  getInformesHorasInstructor,
  getInformesHorasInstructorCount,
  getInformesHorasInstructorExcel,
  setInformesHorasInstructorCount,
} from 'store/informes/actions';
import {
  makeSelectInformesHorasInstructor,
  makeSelectInformesHorasInstructorCount,
} from 'store/informes/selectors';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import {
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
  makeSelectPerfilesUsuarioIdUsuario,
} from 'store/usuarios/selectors';
import { getMonthName } from 'utils/dates-validators';
import { hasAccess } from 'utils/listUtils';
import { formatMinutes } from 'utils/practiceUtils';
import { userProfile } from 'utils/profilesIndex';
import { ReportInstructorHoursFilter } from './ReportInstructorHoursFilter/ReportInstructorHoursFilter';
import './ReportInstructorHours.scss';
import { makeSelectModalDraftType, makeSelectMsgSubmit } from 'store/app/selectors';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  idUsuario: makeSelectPerfilesUsuarioIdUsuario(),
  access_token: makeSelectTokenAccessToken(),
  msgSubmit: makeSelectMsgSubmit(),
  modalDraftType: makeSelectModalDraftType(),
  cursos: makeSelectInformesHorasInstructor(),
  cursosCount: makeSelectInformesHorasInstructorCount(),
} as any);

export const links = [
  {
    label: 'Informes de horas formación de instructor',
    link: '#',
    textHelp: 'Informes de horas formación de instructor',
    active: true,
  },
];

const ReportInstructorHours = (): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { access_token, cursos, profileActive, cursosCount, idUsuario, msgSubmit, modalDraftType } =
    useSelector<any, any>(selectors);
  const redirect = (e: any) => {
    history.push(e.detail);
  };
  // fechaInicio: getTodayMinus15(),
  const defaultFilter = {
    meses: new Date().getMonth(),
    anyo: new Date().getFullYear(),
    instructores: profileActive?.ID_PERFIL === '211' ? idUsuario : '',
    elemInicio: 0,
    elemFin: 25,
    elemFinal: 25, // Algunas peticiones cambian el nombre del parámetro
    savedFilter: false,
  };

  const [initFilter, setInitFilter] = useState(
    window.location.pathname === RouteTypes.REPORT_HOURS_INSTRUCTOR
      ? JSON.parse(
        sessionStorage.getItem(`savedFilter-${window.location.pathname}`) ||
        JSON.stringify(defaultFilter)
      )
      : defaultFilter
  );

  useEffect(() => {
    const savedFilterInstructor = JSON.parse(
      sessionStorage.getItem(`savedFilter-${window.location.pathname}`) ||
      JSON.stringify(defaultFilter)
    );

    if (
      savedFilterInstructor.savedValues === true &&
      savedFilterInstructor.lastProfile === profileActive?.ID_PERFIL
    ) {
      setInitFilter(savedFilterInstructor);
    } else if (
      savedFilterInstructor.savedValues === false ||
      savedFilterInstructor.lastProfile !== profileActive?.ID_PERFIL
    ) {
      setInitFilter(defaultFilter);
    }
  }, [profileActive]);

  const {
    filterRef,
    data,
    setData,
    headers,
    handleFilterTable,
    handleFilterChange,
  } = useList(
    { ...initFilter },
    [
      { text: 'Fecha' },
      { text: 'Matrícula Instructor' },
      { text: 'Instructor' },
      { text: 'Horas validadas' },
      { text: 'Horas pendientes de validar' },
      { text: 'Otras prácticas formativas' },
      { text: 'Total horas' },
    ],
    {
      action: (filter) => {
        return dispatch(getInformesHorasInstructor(filter));
      },
      headerToAPIMap: {},
    },
    (filter) => {
      dispatch(setInformesHorasInstructorCount(0));

      dispatch(getInformesHorasInstructor(filter));
      dispatch(getInformesHorasInstructorCount(filter));
    },
    async () => {
      dispatch(setLoading(true));
      await new Promise(resolve => setTimeout(resolve, 90));
      dispatch(setLoading(false));
    }
  );

  const handleExportExcel = () => {
    const excelColumns = [...headers];
    /* excelColumns.splice(1, 0, { text: 'Matrícula' }) */
    dispatch(
      getInformesHorasInstructorExcel({
        filter: { ...filterRef.current },
        excelConfig: {
          literals: [...excelColumns, { text: 'Días con exceso de jornada' }],
        },
      })
    );
  };

  useEffect(() => {
    if (profileActive) {
      if (profileActive?.ID_PERFIL === '211') {
        filterRef.current.instructores = idUsuario;
      }
      dispatch(getInformesHorasInstructor(filterRef.current));
      dispatch(getInformesHorasInstructorCount(filterRef.current));
    }
  }, [profileActive]);

  useEffect(() => {
    if (!profileActive) {
      return;
    }

    const cursosParsed = cursos.map((item) => {
      const linkIdInstructor = RouteTypes.PRACT_HOURS_INSTRUCTOR.replace(
        ':idInstructor?',
        item.ID_INSTRUCTOR
      )
        .replace(':anyo?', item.ANYO)
        .replace(':mes?', item.MES);

      //:idInstructor?/:anyo?/:mes?

      return {
        table: [
          [
            {
              text: getMonthName(item.MES) + ' ' + item.ANYO,
              className: item.MESSAGE_INFO !== '' ? 'test-class-name' : '',
            },
            {
              text: item.ID_INSTRUCTOR,
              urlLink: linkIdInstructor,
              className: item.MESSAGE_INFO !== '' ? 'test-class-name' : '',
            },
            {
              text: item.nombre_parsed,
              urlLink: linkIdInstructor,
              className: item.MESSAGE_INFO !== '' ? 'test-class-name' : '',
            },
            {
              text: formatMinutes(item.SUMATORIO_VA),
              className: item.MESSAGE_INFO !== '' ? 'test-class-name' : '',
            },
            {
              text: formatMinutes(item.SUMATORIO_PV),
              className: item.MESSAGE_INFO !== '' ? 'test-class-name' : '',
            },
            {
              text: formatMinutes(item.SUMATORIO_TM),
              className: item.MESSAGE_INFO !== '' ? 'test-class-name' : '',
            },
            item.MESSAGE_INFO !== ''
              ? {
                text: formatMinutes(item.TOTAL_TIEMPO),
                tooltip: [
                  {
                    title:
                      'Se ha excedido el tiempo de cálculo de jornada de 8 h. en los siguientes días: ',
                  },
                  {
                    paragraph: item.MESSAGE_INFO,
                  },
                ],
                className: 'position_icon test-class-name',
              }
              : {
                text: formatMinutes(item.TOTAL_TIEMPO),
              },
          ],
        ],
      };
    });

    setData(cursosParsed);
  }, [cursos]);

  if (
    !hasAccess(profileActive, [
      userProfile.gestor,
      userProfile.administrador,
      userProfile.formador,
      userProfile.instructor,
      userProfile.supervisor,
      userProfile.visualizador,
    ])
  ) {
    return <Redirect to={RouteTypes.HOME} push />;
  }

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  return (
    <div className="report-hours-container">
      <Header />
      <div className="rf-layout-table rf-practice-list">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">
          Informes de horas formación de instructor
        </h1>

        <ReportInstructorHoursFilter handleSubmit={handleFilterChange} />

        <Table
          redirect={(e: any) => {
            redirect(e);
          }}
          list={false}
          data={data}
          dataCount={cursosCount}
          headers={headers}
          handleFilter={handleFilterTable}
          hideAudit={true}
          handleExportExcel={handleExportExcel}
          pagination25={true}
          orderMobile={false}
          itemsOnLeft={4}
          isReportHours={true}
        />
      </div>
      <RfUiModal
        title-modal={msgSubmit}
        modalConfirmText="Aceptar"
        id-modal="modalDraft"
        modal-type={modalDraftType}
        onModalClose={(e: any) => {
          dispatch(setMsgSubmit(''));
          dispatch(setModalDraftType(''));
        }}
        onConfirm={(e: any) => {
          dispatch(setMsgSubmit(''));
          dispatch(setModalDraftType(''));
        }}
      ></RfUiModal>
    </div>
  );
};

export default ReportInstructorHours;
